import React, { memo, useCallback } from 'react'
import { Modal } from '../modal'
import CsvDownloadForm from '../csvDownload/csvDownloadForm'
import { ExportModalProps } from './types'

const ExportModal = ({
   title,
   isOpen,
   setIsOpen,
   fileName,
   path,
   query,
   filters,
   setIsDownloading,
   isDownloading,
   defaultParams,
   buttonRef,
}: ExportModalProps) => {
   const handleClose = useCallback(() => setIsOpen(false), [setIsOpen])

   return (
      <Modal title={title} isModalVisible={isOpen} closeModal={handleClose}>
         <CsvDownloadForm
            fileName={fileName}
            closeModal={handleClose}
            path={path}
            query={query}
            filters={filters}
            setIsDownloading={setIsDownloading}
            isDownloading={isDownloading}
            defaultParams={defaultParams}
            buttonRef={buttonRef}
         />
      </Modal>
   )
}

export default memo(ExportModal)
